export default "__VITE_ASSET__BNlOy9qs__"